import type { FC } from 'react';

import { useAuth } from '@nodal/api/auth';
import { useEffect } from 'react';
import { useNavigate, matchPath } from 'react-router-dom';

import {
  candidatePaths,
  organizationPaths,
  externalPayerPaths,
} from '@b2b/consts/paths';

import type { LogoutProps } from './Logout.interface';

export const logout = () => {
  if (
    matchPath(candidatePaths.signin, window.location.pathname) &&
    matchPath(candidatePaths.logout, window.location.pathname)
  ) {
    window.location.href = candidatePaths.logout;
  } else if (
    matchPath(organizationPaths.signin, window.location.pathname) &&
    matchPath(organizationPaths.logout, window.location.pathname)
  ) {
    window.location.href = organizationPaths.logout;
  } else if (matchPath(externalPayerPaths.logout, window.location.pathname)) {
    window.location.href = externalPayerPaths.logout;
  }
};

export const Logout: FC<LogoutProps> = ({ redirectPath }) => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(redirectPath);
    auth.tokenProvider.removeTokens();
  }, [navigate, auth, redirectPath]);

  return <></>;
};
